module.exports = __webpack_public_path__ + "static/media/BodyRelaxationTechniques.99eed990.mp3";